// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import { Button, message } from 'ant-design-vue';
window.Vue = Vue;
import App from './App'
import router from './router'
import VueSlimScroll from 'vue-slimscroll'
import datePicker from 'vue-bootstrap-datetimepicker';
import store from './store'
import installer from '@andresouzaabreu/vue-data-table'
import CKEditor from 'ckeditor4-vue';
import FullCalendar from 'vue-full-calendar'
import Select2 from 'v-select2-component';
import InputMask from 'vue-input-mask';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import { Drag, Drop } from 'vue-drag-drop'
import { BarChart } from 'vue-morris'
import { LineChart } from 'vue-morris'
import Multiselect from 'vue-bootstrap-multiselect'
import VueSwal from 'vue-swal'
import Popover from 'vue-js-popover'
import VueNumerals from 'vue-numerals'
import vSelect from 'vue-select'
let bootstrap = require('bootstrap')
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'font-awesome/css/font-awesome.css'
import './assets/style/style.css'
import './assets/style/custom.css'
import 'vue-full-calendar/node_modules/fullcalendar/dist/fullcalendar.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './components/main.js'
import Raphael from 'raphael/raphael'
global.Raphael = Raphael
import VueNoty from 'vuejs-noty'
import 'vuejs-noty/dist/vuejs-noty.css'
import 'vue-select/dist/vue-select.css'

Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(Button);
Vue.use(VueSlimScroll)
Vue.use(datePicker)
Vue.use(CKEditor);
Vue.use(VueSwal);
Vue.use(Popover);
Vue.use(VueNumerals) // default locale is 'en'
Vue.use(VueNoty, {
  timeout: 4000,
  progressBar: true,
  layout: 'topRight',
  theme: 'relax'
})
Vue.use(require('vue-moment'), {moment});
Vue.component('drag', Drag);
Vue.component('drop', Drop);
Vue.component('input-mask', InputMask);
Vue.component('multiselect', Multiselect);
Vue.component('Select2', Select2);
Vue.component('v-select', vSelect);
Vue.use(FullCalendar);
installer(Vue, store)
new Vue({
  store,
  el: '#app',
  router,
  components: { App, BarChart, LineChart, },
  data() {
    return {
      message: 'Hello',
    }
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js